import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AIicon from "../../Assets/landingPage/aiiconb.png";

const Header = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="bg-[#FFF1F1]  text-[#2B2B2A] font-body-md min-h-screen w-full overflow-x-hidden relative">
      {/* Animated Background Elements with Frond Colors */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-[#E65C6C]/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-[#45479C]/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#E37850]/10 rounded-full blur-3xl animate-pulse delay-2000"></div>
      </div>

      {/* Main Content Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="py-12 md:py-16 lg:py-20 text-center flex flex-col items-center gap-4">
          
          {/* Hero content with fade-in animation */}
          <div className={`w-full transition-all duration-1000 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
            
            {/* Main heading with 3 colors */}
           <h1 className="font-display-lg font-bold text-5xl text-display-lg-mobile md:text-display-lg max-w-4xl mx-auto mb-6 leading-[1.2]">
  <span className="bg-gradient-to-r from-[#45479C] via-[#E65C6C] to-[#E37850] bg-clip-text text-transparent">
    Plan the Extraordinary. Together.
  </span>
</h1>
            
            {/* Description */}
            <p className="text-lg md:text-xl text-[#2B2B2A]/70 max-w-2xl mx-auto mb-8 leading-[1.6]">
              From dream weddings to global escapes, Frond's AI engine turns your collective ideas into perfect, actionable plans in seconds.
            </p>
            
            {/* AI Search Bar - Frond Theme */}
            <div className="w-full max-w-3xl mx-auto bg-white rounded-full p-2 flex flex-col md:flex-row items-center gap-2 mb-12 shadow-lg border border-[#EDEDEB]">
              <div className="flex items-center gap-3 px-6 flex-1 w-full">
                <img src={AIicon} alt="AI Icon" className="w-6 h-6" />
                <input 
                  className="bg-transparent border-none focus:ring-0 text-base w-full placeholder:text-[#2B2B2A]/50 outline-none" 
                  placeholder="Tell Frond what you want to plan... (e.g., 'A 10-day sustainable trip to Kyoto for 4 friends')" 
                  type="text"
                />
              </div>
             <button className="bg-[#45479C] text-white px-8 py-4 rounded-full font-bold shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 active:scale-95 w-full md:w-auto whitespace-nowrap">
  Generate My Plan
</button>
            </div>
            
            {/* CTA Buttons - Frond Theme */}
            <div className="flex flex-wrap justify-center gap-4">
             <Link
    to={"/signup"}
    className="bg-[#45479C] text-white px-10 py-4 rounded-full font-bold text-lg shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 active:scale-95"
  >
    Get Started
  </Link>
              
              <Link
                to={"/how-frond-works"}
                className=" bg-red-200  text-[#45479C] px-10 py-4 rounded-full font-bold text-lg flex items-center gap-2 shadow-md hover:shadow-lg transition-all duration-300 hover:scale-105 "
              >
                <svg className="w-6 h-6text-[#E65C6C]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Watch the Magic
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Custom styles */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        
        .delay-1000 {
          animation-delay: 1s;
        }
        
        .delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </section>
  );
};

export default Header;